import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import IUserModel, { defaultUser } from "../models/user";
import { User } from "firebase/auth";
import { Position } from "../Position";
import { Resource } from "../Resource";

export interface CounterState {
  user: IUserModel;
  positions: Position[];
  resources: Resource[];
}

const initialState: CounterState = {
  user: defaultUser,
  positions: [],
  resources: []
};

export const userSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUserModel>) => {
      state.user = action.payload;
    },
    setLocalResources: (state, action: PayloadAction<Resource[]>) => {
      state.resources = action.payload;
    },
    setLocalPositions: (state, action: PayloadAction<Position[]>) => {
      state.positions = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const { setUser, setLocalResources, setLocalPositions } = userSlice.actions;

export default userSlice.reducer;
